import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import PrevNext from '../prevAndNext/PrevNext';
import CommonOrderTable from '../common/orders/CommonOrderTable';
import CommonOrderTopTextFields from '../common/orders/CommonOrderTopTextFields';
import OrderPaymentInformation from '../common/orders/OrderPaymentInformation';
import CommonOrderDateTimeDock from '../common/orders/CommonOrderDateTimeDock';
import CommonOrderAdditionalInformation from '../common/orders/CommonOrderAdditionalInformation';
import CommonOrderTruckerInformation from '../common/orders/CommonOrderTruckerInformation';

import DockerOverloadModalContainer from '../dockOverloadModal/DockerOverloadModalContainer';
import CommonOrderTruckingInfoWrapper from '../common/orders/CommonOrderTruckingInfoWrapper';
import ManualEntryOrderDriverInfo from '../common/orders/ManualEntryOrderDriverInfo';

import style from '../common/orders/ordersStyle.module.css';
import commonStyles from '../common/common.module.css';
import pickupOrderStyles from './pickupOrder.module.css';

import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import User, { UserRoleType } from '../../models/User';
import PickupOrderModel from '../../models/PickupOrder';
import PaymentsPO from '../../models/PaymentsPO';

import { Moment } from 'moment';

const styles = (theme: Theme) =>

  createStyles({
    btnWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px'
    },
    update: {
      width: '200px',
    }
  });

interface PickupOrderProps {
  classes: any;
  pickupOrder: PickupOrderModel;
  user: User;
  initialDeliveryCompanyID: number | undefined;
  pickupDateErrorMsg: string;
  showDetails: boolean;
  deleteOrder: boolean;
  pickupDate: Moment;
  showTruckerInfo?: boolean;
  showNotify: boolean;
  backToList?: boolean;
  selectedDeliveryCompanyID: number | undefined;
  payments: PaymentsPO;
  openDockOverloadModal: boolean;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  handleSelectPickUpTime: () => void;
  pickupDateChange: (type: string, date: Moment) => void;
  handleFieldsInput: (fieldName: string, event: any) => void;
  setContainerState: (data: any) => void;
  hideTruckerInfo: () => void;
  setDriverID: Function;
  selectedDriverID: number | undefined;
  changedDriver: Function;
  initialDriverID: number | undefined;
  changeDriverDetails: Function;
  resetPickupTime: () => void;
  handleSetDeliveryCompanyID: (deliveryCompanyID: number) => void;
  changedDeliveryCompany: (newDeliveryCompanyID: number) => void;
  submitPickupOrder: () => void;
  handleCloseDockOverloadModal: (time: string) => void;
  lastAwbDeletionWarning: ((callback: () => void) => void);
  showLine: boolean;
  sendOrder: string;
  handleChangeSendOrder: (event: any) => void;
  userRole: UserRoleType;
  handleClick: Function;
  maskOn: Function;
  type?: string;
};

const pickupOrder = (props: PickupOrderProps) => {
  const prevButtonHref: string = (!props.userRole || props.userRole === UserRoleType.FORWARDER) ? '/pay' : '/manual-entry-pay';

    return (
      <div className={ style.orderWrapper }>

        <div className= { commonStyles.headerDummyDiv }> </div>
        
        { props.showLine && 
          
          <div className={ style.firstHorizontalLine } />
        }

        { !props.showLine && 
          
          <div className={ style.marginTop } />
        }

        <CommonOrderDateTimeDock
          pickupOrder={ props.pickupOrder }
          handleSelectPickUpTime={ props.handleSelectPickUpTime }
          pickupDate={ props.pickupDate }
          pickupDateChange={ () => {}}
          cutoffDate={ props.pickupOrder.cutoff_date }
          cutoffTime={ props.pickupOrder.cutoff_time }
          userRole={ props.userRole }
          changeInputCutOffTime={ ()=>{}}
          type='po'
        />

        <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
          <h3 className={ `${ commonStyles.header }` }>Additional Information</h3>
          <CommonOrderTopTextFields
            pickupOrder={ props.pickupOrder }
            handleFieldsInput={ props.handleFieldsInput }
            type={ 'po' }
            userRole={ '' }
          />
          { (!props.userRole || props.userRole === UserRoleType.FORWARDER) &&

            <CommonOrderAdditionalInformation
              pickupOrder={ props.pickupOrder }
              handleFieldsInput={ props.handleFieldsInput }
              type={ 'po' }
            />
          }
        </div>

        { props.userRole === UserRoleType.GHA &&
          <ManualEntryOrderDriverInfo pickupOrder={ props.pickupOrder }/>
        }

        { props.type === 'go' && props.pickupOrder.allowed_ops.update_awb_address &&
          <div className={ pickupOrderStyles.goEditWrapper }>
            <Link to={{ pathname: "/create-go-order", state: { editOrderNumber: props.pickupOrder.number } }} className={ pickupOrderStyles.goEditLink }>
              <Button color="primary" variant="contained" onClick={() => sessionStorage.setItem('editGoOrderNumber', props.pickupOrder.number)}>
                Edit GO Order
              </Button>
            </Link>
          </div>
        }

          <CommonOrderTable 
            pickupOrder={ props.pickupOrder } 
            setState={ props.setContainerState }
            editErrors={ props.editErrors }
            type={ props.type || 'po' }
            lastAwbDeletionWarning={ props.lastAwbDeletionWarning }
          />

        { (!props.userRole || props.userRole === UserRoleType.FORWARDER) &&
        <Fragment>
          { props.type !== 'go' && <OrderPaymentInformation payments={ props.payments } /> }
         
        { props.type !== 'go' && (
          <CommonOrderTruckingInfoWrapper
            type={ props.type || 'po' }
            selectedDeliveryCompanyID={ props.showDetails ? props.selectedDeliveryCompanyID : props.pickupOrder.id_delivery_company || undefined }
            setDeliveryCompanyID={ props.handleSetDeliveryCompanyID }
            showDetails={ props.showDetails }
            setDriverID= { props.setDriverID }
            selectedDriverID= { props.selectedDriverID }
            changedDriver= { props.changedDriver }
            initialDriverID= { props.initialDriverID }
            hideTruckerInfo={ props.hideTruckerInfo }
            resetPickupTime={ props.resetPickupTime }
            changedDeliveryCompany={ props.changedDeliveryCompany }
            initialDeliveryCompanyID={ props.initialDeliveryCompanyID }
            order={ props.pickupOrder }
            sendOrder={ props.sendOrder }
            handleChangeSendOrder={ props.handleChangeSendOrder } 
            changeDriverDetails={ props.changeDriverDetails }
            submitPickupOrder={ props.submitPickupOrder }
            maskOn={ props.maskOn }
            handleClick={ props.handleClick }
          />
        )}
    
  
        { props.showTruckerInfo && props.pickupOrder.id_delivery_company && props.type !== 'go' &&
          <CommonOrderTruckerInformation
            pickupOrder={ props.pickupOrder }
            type={ props.type || 'po' }
          />
        }
        </Fragment>
        }

        { props.openDockOverloadModal &&
          <DockerOverloadModalContainer 
            openDockOverloadModal={ props.openDockOverloadModal }
            handleCloseDockOverloadModal={ props.handleCloseDockOverloadModal }
            forInfo={ false }
            ghaID={ props.pickupOrder.id_gha }
            type={ 'import' }
            date={ props.pickupOrder.pickup_date }
            time={ props.pickupOrder.pickup_time }
          />
        }

        { props.userRole === UserRoleType.GHA &&
          <div className={ props.classes.btnWrapper}>
            <Link to={{  pathname: '/manage-imports', state: !props.deleteOrder ? { orderNumber: props.pickupOrder.number, orderType: 'po' } : { orderType: 'po' }  }} ><Button className={ props.classes.return }  color="primary" variant="contained">Go To Manage Import</Button></Link>
            <Button className={ props.classes.update } onClick={ props.submitPickupOrder } color="primary" variant="contained" >Update</Button>
          </div>
        }

        { (
          props.backToList
            ? <PrevNext prevButton={ { active: true, href: props.type === 'go' ? '/my-go-orders' : '/my-pick-up-orders', animate: true } } />
            : <PrevNext prevButton={ { active: true, href: `${prevButtonHref}`, animate: true } } />
        ) }

      </div>
    )
}

export default withStyles(styles)(pickupOrder); 
